<template>
  <div class="cat-year-label-wrapper"
    :class="numQuarters">
    <div class="cat-year-label">{{yearData.year}}</div>
    <div class="quarters-label-wrapper">
      <div v-for="quarter in yearData.quarters" 
        :key="`${yearData.year}_${quarter.quarter}`"
        class="quarter-label">
          {{quarter.quarter}}
      </div>
    </div>
  </div>
</template>

<script>
import numQuarters from '../../helpers/numQuarters';

export default {
  name: 'map-controls-dates-column',
  props: ['yearData'],
  computed: {
    numQuarters,
  },
};
</script>

<style lang="less">
  .cat-year-label-wrapper {
    margin-right: 7px;
    padding-left: 3px;
    @media all and (-ms-high-contrast: none), (-ms-high-constrast: active) {
      padding-left: 0px;
    }
  }
  .cat-year-label {
    font-weight: bold;
    padding-top: 3px;
  }
  .quarters-label-wrapper {
    display: flex;
    width: 100%
  }
  .quarter-label {
    flex: 1 1 25%;
  }
</style>



// WEBPACK FOOTER //
// MapControlsDatesColumn.vue?b1c6097a